<template>
    <section class="section">
        <div class="container-fluid">
            <h1 class="title">{{ translate("admin_users.title") }}</h1>

            <template v-if="filterUserId === 0">
                <div class="mb-4">
                    <a :href="usersCsvUrl" class="button is-primary">
                        {{ translate("admin_users.download_users_list") }}
                    </a>
                </div>

                <div class="columns">
                    <div class="column is-one-third">
                        <div class="field">
                            <div class="control has-icons-right">
                                <input v-model="filterText" type="text" class="input" :placeholder="translate('common.filter')" />
                                <span class="icon is-right">
                                    <i class="fas fa-search" />
                                </span>
                            </div>
                            <p class="help">
                                {{ translate("common.items_found") }}:
                                <span id="filterResultCount">{{ filteredUsers.length }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="mb-4">
                    <button @click="resetFilters" class="button">
                        {{ translate("admin_user.show_all_users") }}
                    </button>
                </div>
            </template>

            <div v-if="initialLoadFinished && filteredUsers.length > 0">
                <div class="table-container">
                    <table class="table is-hoverable is-fullwidth">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{{ translate("common.first_name_and_last_name") }}</th>
                                <th>{{ translate("common.email") }}</th>
                                <th>{{ translate("common.phone") }}</th>
                                <th>{{ translate("common.academy") }}</th>
                                <th>{{ translate("common.branch_city") }}</th>
                                <th>{{ translate("admin_users.total_competitors") }}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(user, index) in filteredUsers" :key="user.id">
                                <td>{{ index + 1 }}</td>
                                <td class="clarity-mask">{{ user.firstName }} {{ user.lastName }}</td>
                                <td class="clarity-mask">{{ user.email }}</td>
                                <td class="clarity-mask">{{ user.phone }}</td>
                                <td>{{ user.academy.name }}</td>
                                <td>{{ user.branch }}</td>
                                <td>
                                    <a :href="getUserCompetitorsRedirectUrl(user.id)">{{ user.totalCompetitors }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-else-if="requestsInProgress > 0" class="has-text-centered">
                <LoadingSpinner2 />
            </div>
        </div>
    </section>
</template>

<script>
    import requestMixin from "../Common/requestMixin";
    import objectMatcher from "../Common/objectMatcher";
    import historyManager from "../Common/history";
    import translatorMixin from "../Common/translatorMixin";
    import urlsMixin from "../Urls/urlsMixin";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";

    const hmInstance = historyManager.getInstance(window);

    export default {
        name: "event-admin-users-view-app",
        components: {
            LoadingSpinner2,
        },
        mixins: [requestMixin, translatorMixin, urlsMixin],
        props: ["usersCsvUrl", "usersUrl", "userCompetitorsRedirectUrl", "eventId"],
        data() {
            return {
                processingUserId: 0,
                initialLoadFinished: false,
                users: [],
                filteredUsers: [],
                filterText: "",
                filterUserId: 0,
            };
        },
        watch: {
            filterText() {
                this.filterUsers();
            },
        },
        mounted() {
            this.filterText = hmInstance.getQueryParam("filterText") || "";
            this.filterUserId = parseInt(hmInstance.getQueryParam("userId"), 10) || 0;

            this.fetchUsers(() => {
                this.initialLoadFinished = true;
            });
        },
        methods: {
            fetchUsers(callback) {
                this.request(
                    {
                        method: "get",
                        url: this.usersUrl,
                        json: true,
                    },
                    (err, response) => {
                        if (response.statusCode === 200) {
                            this.users = response.body;
                            this.filterUsers();
                            if (callback) {
                                callback();
                            }
                        } else {
                            alert("Could not fetch users listing.");
                        }
                    },
                );
            },
            getUserCompetitorsRedirectUrl(userId) {
                return this.eventAdmin().registeredCompetitorsForUserPage(this.eventId, userId);
            },
            filterUsers() {
                hmInstance.setQueryParam("filterText", this.filterText);

                this.filteredUsers = this.users.filter(user => {
                    if (this.filterUserId > 0) {
                        return user.id === this.filterUserId;
                    }

                    const userAsText = `${user.firstName} ${user.lastName} ${user.email} ${user.academy.name} ${user.branch}`;
                    return objectMatcher.matchString(this.filterText, userAsText);
                });
            },
            resetFilters() {
                this.filterUserId = 0;
                hmInstance.setQueryParam("userId", null);
                this.filterText = "";
                hmInstance.setQueryParam("filterText", null);
                this.filterUsers();
            },
        },
    };
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.4s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
